module.exports = __webpack_public_path__ + "static/media/xia.964d555e.jpg";